export default "__VITE_ASSET__CTe3Ke8T__"